import React from 'react';
import PropTypes from 'prop-types';
import './BannerPageImg.css';

const BannerPageImg = ({ src, alt }) => {
    return (
        <div className='page-banner-img-box'>
            <img className='page-banner-img' src={src} alt={alt}/>
        </div>
    );
};

BannerPageImg.propTypes = {
    src: PropTypes.string.isRequired,
    alt: PropTypes.string,
};

BannerPageImg.defaultProps = {
    alt: 'Banner page Image',
};

export default BannerPageImg;
